/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComplaintSummaryResponse
 */
export interface ComplaintSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof ComplaintSummaryResponse
     */
    inputTokenCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ComplaintSummaryResponse
     */
    outputTokenCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ComplaintSummaryResponse
     */
    caseType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ComplaintSummaryResponse
     */
    caseSummary?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ComplaintSummaryResponse
     */
    caseParties?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComplaintSummaryResponse
     */
    keyFacts?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComplaintSummaryResponse
     */
    claimsAndAllegations?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ComplaintSummaryResponse
     */
    oneSentenceCaseDescription?: string | null;
}

export function ComplaintSummaryResponseFromJSON(json: any): ComplaintSummaryResponse {
    return ComplaintSummaryResponseFromJSONTyped(json, false);
}

export function ComplaintSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplaintSummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inputTokenCount': !exists(json, 'inputTokenCount') ? undefined : json['inputTokenCount'],
        'outputTokenCount': !exists(json, 'outputTokenCount') ? undefined : json['outputTokenCount'],
        'caseType': !exists(json, 'case_type') ? undefined : json['case_type'],
        'caseSummary': !exists(json, 'case_summary') ? undefined : json['case_summary'],
        'caseParties': !exists(json, 'case_parties') ? undefined : json['case_parties'],
        'keyFacts': !exists(json, 'key_facts') ? undefined : json['key_facts'],
        'claimsAndAllegations': !exists(json, 'claims_and_allegations') ? undefined : json['claims_and_allegations'],
        'oneSentenceCaseDescription': !exists(json, 'one_sentence_case_description') ? undefined : json['one_sentence_case_description'],
    };
}

export function ComplaintSummaryResponseToJSON(value?: ComplaintSummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inputTokenCount': value.inputTokenCount,
        'outputTokenCount': value.outputTokenCount,
        'case_type': value.caseType,
        'case_summary': value.caseSummary,
        'case_parties': value.caseParties,
        'key_facts': value.keyFacts,
        'claims_and_allegations': value.claimsAndAllegations,
        'one_sentence_case_description': value.oneSentenceCaseDescription,
    };
}


